import { Component } from 'preact';
import SaveRow from './SaveRow';
import RuneSpinner from '../RuneSpinner';
import { TEXT_MUTED } from '../../lib/medievalTheme';
import { t } from '../../localization/t';

export default class SaveList extends Component {
  render() {
    const { instances, loading, currentUserId, onAction, savedNamesByInstance, sorceryCards } = this.props;
    if (loading) {
      return (
        <div className="flex justify-center py-8">
          <RuneSpinner size={48} />
        </div>
      );
    }
    if (!instances?.length) {
      return (
        <div className="vh-empty-state">
          <div className="vh-empty-state-headline">{t('No saves yet')}</div>
          <p className="vh-empty-state-hint">
            {t('Start a new session on the left. Any match you begin will be saved here so you can pick it back up later.')}
          </p>
        </div>
      );
    }
    return (
      <div className="flex flex-col gap-2">
        {instances.map((inst) => (
          <SaveRow
            key={inst.id}
            instance={inst}
            savedName={savedNamesByInstance?.get?.(inst.id) || null}
            currentUserId={currentUserId}
            sorceryCards={sorceryCards}
            onAction={onAction}
          />
        ))}
      </div>
    );
  }
}
